import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgHcaptchaModule } from 'ng-hcaptcha';

import { environment } from 'src/environments/environment';

import { APP_ROUTES } from './app.routes';
import { AppErrorHandler } from './app-error-handler';
import { ApiInterceptor } from './helpers/interceptors/api.interceptor';
import { ApiErrorInterceptor } from './helpers/interceptors/api.error.interceptor';
import { ApplicationInsightsService } from './services/application-insights/application-insights.service';

export function getBaseUrl(): string {
  return document.getElementsByTagName('base')[0].href;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES, withHashLocation(), withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(NgHcaptchaModule.forRoot({ siteKey: environment.hCaptchaSiteKey })),
    importProvidersFrom(NgbModule),
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    CookieService,
    ApplicationInsightsService
  ]
};
